import { makeStyles } from '@fluentui/react-components';
import { helpbuttonStyle } from '@bingads-webui-campaign-react/common-styles';

export const useDefaultContainerStyles = makeStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    rowGap: '16px',
  },
});

export const getStyles = (_, core) => ({
  collapseContainer: {
    '& .helpbutton': {
      ...helpbuttonStyle(core)['.helpbutton'],
      marginBottom: '4px',
      display: 'inline-block',
    },
    '& .helpbutton::before': helpbuttonStyle(core)['.helpbutton::before'],
  },
});
